import styled from '@emotion/styled';
import AddItemButton from '../AddItemButton';
import emotionFirstChildSelector from '@/lib/styling/emotionFirstChildSelector';

const AddSubtopicButton = styled(AddItemButton)({
  marginTop: 22,
  [emotionFirstChildSelector]: {
    marginTop: -8,
  },
});

export default AddSubtopicButton;
